function setCtmThumbActive(thumbEl, activeIndex) {
  thumbEl.querySelectorAll(".swiper-slide").forEach(function (slide, i) {
    slide.classList.toggle("swiper-slide-thumb-active", i === activeIndex);
  });
}

function initCtmPdpSliders() {
  if (typeof Swiper === "undefined") {
    setTimeout(initCtmPdpSliders, 50);
    return;
  }

  document.querySelectorAll(".ctm-pdp-media-sliders").forEach((root) => {
    const thumbEl = root.querySelector(".ctm_pdp_mainproduct_thumbnail_slider");
    const mainEl = root.querySelector(".ctm_pdp_mainproduct_slider");
    const prevEl = root.querySelector(".ctm-pdp-thumb-nav--prev");
    const nextEl = root.querySelector(".ctm-pdp-thumb-nav--next");
    if (!thumbEl || !mainEl) return;

    const thumbsOptions = {
      direction: "horizontal",
      loop: false,
      spaceBetween: 10,
      slidesPerView: 5,
      speed: 600,
      freeMode: false,
      watchSlidesProgress: true,
      watchOverflow: true,
      roundLengths: true,
    };

    if (prevEl && nextEl) {
      thumbsOptions.navigation = { prevEl, nextEl };
    }

    const swiperThumbs = new Swiper(thumbEl, thumbsOptions);

    const mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      grabCursor: true,
      draggable: true,
      loop: false,
      spaceBetween: 2,
      speed: 600,
      roundLengths: true,
      thumbs: {
        swiper: swiperThumbs,
      },
      on: {
        init: function () {
          setCtmThumbActive(thumbEl, this.activeIndex);
        },
        slideChange: function () {
          setCtmThumbActive(thumbEl, this.activeIndex);
        },
      },
    });

    thumbEl
      .querySelectorAll(".ctm-pdp-thumb-slide")
      .forEach(function (slide, index) {
        slide.addEventListener("click", function () {
          mainSwiper.slideTo(index);
        });
      });
  });
}

document.addEventListener("DOMContentLoaded", initCtmPdpSliders);

/* ===== hnc-product-card ===== */
if (!customElements.get("hnc-product-card")) {
  customElements.define(
    "hnc-product-card",
    class extends HTMLElement {
      connectedCallback() {
        this.priceEl = this.querySelector("[data-hnc-price]");
        this.variantInput = this.querySelector("[data-hnc-variant-input]");
        this.submitBtn = this.querySelector('[type="submit"]');
        this.chips = Array.from(this.querySelectorAll("[data-hnc-chip]"));
        this.onChipClick = this.onChipClick.bind(this);
        this.chips.forEach((chip) =>
          chip.addEventListener("click", this.onChipClick),
        );
      }
      disconnectedCallback() {
        this.chips.forEach((chip) =>
          chip.removeEventListener("click", this.onChipClick),
        );
      }
      onChipClick(event) {
        const chip = event.currentTarget;
        if (chip.classList.contains("is-active")) return;
        this.chips.forEach((c) => {
          c.classList.remove("is-active");
          c.setAttribute("aria-pressed", "false");
        });
        chip.classList.add("is-active");
        chip.setAttribute("aria-pressed", "true");
        if (this.priceEl) this.priceEl.textContent = chip.dataset.hncPrice;
        if (this.variantInput) {
          this.variantInput.value = chip.dataset.hncVariantId;
        }
        const available = chip.dataset.hncAvailable !== "false";
        if (this.submitBtn) {
          this.submitBtn.disabled = !available;
          this.submitBtn.toggleAttribute("aria-disabled", !available);
        }
      }
    },
  );
}
